module.exports = __webpack_public_path__ + "common/loading-92dd2f3868a7d1283d4d79284e91c0fe.svg";